import React, {useEffect, useRef, useState} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import {useDispatch} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {login} from "../store/slices/AuthSlice";
import get from "lodash.get";
import {createNewUser, login as loginHandler} from "../utils/API";
import Logo from "../assets/logo_vitraya_white.png";
import HeroImage from "../assets/img1.jpg";
import {Grid, InputAdornment} from "@mui/material";
import LoadingComponent from "../components/core/LoadingComponent";
import {showToast} from "../utils/tostr";
import SelectComponent from "../components/core/SelectComponent";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {isApiUserAndIframeUser, UserTypes} from "../constants/UserAuth";

const useStyles = makeStyles((theme) => ({
    LeftContainer: {
        //margin:theme.spacing(3),
        display: "flex",
        flexDirection: "column !important",
        flexWrap: "warp",
        alignItems: "center",
        padding: theme.spacing(2),
        background: "#4D88FE",
        minHeight: "100vh",
        minWidth: "50vh",
    },
    paper: {
        margin: theme.spacing(8),
        // marginBottom: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(3),
    },
    avatar: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        width: "12rem",
        borderRadius: "3px",
        marginBottom: theme.spacing(2),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
        color: "#fff",
    },
    submit: {
        marginTop: theme.spacing(2),
    },
    branding: {
        //fontFamily: 'AvantGardeRegular',
        color: "#000",
    },
}));

export default function LoginPage(props) {
    const {mode} = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    // const[createUser,setCreateUser]=useState({})
    const newEmail = useRef();
    const newPassword = useRef();
    const mobileNumber = useRef();
    const userName = useRef();
    const [role, setRole] = useState();

    const onChangeHandler = (event) => {
        const {name, value} = event.currentTarget;

        if (name === "userEmail") {
            setEmail(value);
        } else if (name === "userPassword") {
            setPassword(value);
        }
    };

    const signInWithEmailAndPasswordHandler = async (event) => {
        event.preventDefault();
        setIsLoggingIn(true);

        const response = await loginHandler(email, password);
        if (response.success === false) {
            setIsLoggingIn(false);
            setError(response.data ? response.data.replaceAll("_", " ") : response.message.text);
        } else {
            dispatch(
                login({
                    email: email,
                    token: get(response, ["token"], ""),
                    role: get(response, ["role"], ""),
                })
            );

            setIsLoggingIn(false);

            if (!isApiUserAndIframeUser()) {
                navigate("/");
            } else {
                showToast(
                    "This user is not allowed to view the dashboard.",
                    "error",
                    "EXTERNAL_API_SUPPORT"
                );
            }
        }
    };
    const signUpNewUser = async (event) => {
        event.preventDefault();
        const data = {
            email: newEmail.current?.value,
            password: newPassword.current?.value,
            contactNo: mobileNumber.current?.value,
            userAlias: userName.current?.value,
            role: role,
            corporateId: parseInt(localStorage.getItem("insurerId")),
        };
        const response = await createNewUser(data);
        if (response.success === false) {
            setIsLoggingIn(false);
            setError(response.data);
            showToast("User not created successfully", "error", "create_user-failed");
        } else {
            setIsLoggingIn(false);

            showToast("User created successfully", "success", "create_user");
        }
    };

    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        setIsSafari(
            userAgent.includes("applewebkit") && !userAgent.includes("chrome")
        );
    }, []);

    //   TODO: Change the layout for login page
    return (
        <>
            <CssBaseline/>
            {isSafari ? (
                <>
                    <div
                        style={{
                            fontFamily: "Arial, sans-serif",
                            backgroundColor: "#f7f7f7",
                            margin: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100vh",
                        }}
                    >
                        <div
                            style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "white",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                borderRadius: "8px",
                                maxWidth: "600px",
                            }}
                        >
                            <h1 style={{color: "#333", marginBottom: "20px"}}>
                                Optimized for Chrome
                            </h1>
                            <p style={{color: "#666", lineHeight: "1.6"}}>
                                This site works best with the Google Chrome browser. To ensure
                                the best experience, we recommend using Chrome on your Mac.
                            </p>
                            <h2>How to Install Chrome on Mac:</h2>
                            <ol
                                style={{
                                    textAlign: "left",
                                    maxWidth: "400px",
                                    margin: "0 auto",
                                    paddingLeft: "20px",
                                }}
                            >
                                <li>Open Safari or your current browser.</li>
                                <li>
                                    Go to{" "}
                                    <a
                                        href="https://www.google.com/chrome"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: "#007bff", textDecoration: "none"}}
                                    >
                                        https://www.google.com/chrome
                                    </a>
                                </li>
                                <li>Click on the "Download Chrome" button.</li>
                                <li>Open the downloaded file.</li>
                                <li>
                                    Drag and drop the Chrome icon into the Applications folder.
                                </li>
                                <li>
                                    Open Chrome from the Applications folder and start browsing!
                                </li>
                            </ol>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    {isLoggingIn === true && <LoadingComponent/>}
                    {isLoggingIn === false && (
                        <Grid container maxWidth={"xl"}>
                            {mode === "signup" && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        border: "1px solid",
                                        padding: 10,
                                        height: "3rem",
                                        marginLeft: 30,
                                        marginTop: 30,
                                        background: "#000",
                                        cursor: "pointer",
                                    }}
                                >
                                    <Link
                                        to={"/"}
                                        style={{textDecoration: "none", color: "#fff"}}
                                    >
                                        Go Back
                                    </Link>
                                </div>
                            )}
                            {mode === "signin" && (
                                <Grid item xl lg md xs={7} className={classes.LeftContainer}>
                                    <Typography
                                        component="h1"
                                        variant="h4"
                                        style={{
                                            color: "#fff",
                                            fontFamily: "AvantGardeRegular",
                                            padding: 10,
                                        }}
                                    >
                                        One destination for all your claims
                                    </Typography>
                                    <Grid style={{paddingTop: "10vh"}}>
                                        <img alt="" src={HeroImage} style={{width: "100%"}}/>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid
                                item
                                xl
                                lg
                                md
                                xs={4}
                                style={{
                                    minHeight: "100vh",
                                    minWidth: "50vh",
                                    paddingTop: mode === "signin" ? "20vh" : "1vh",
                                }}
                            >
                                <div className={classes.paper}>
                                    <img className={classes.avatar} src={Logo} alt=""/>
                                    <Typography
                                        component="h1"
                                        variant="h5"
                                        className={classes.branding}
                                    >
                                        {mode === "signin" && "Insurer Dashboard"}
                                        {mode === "signup" && "Create user for Insurer Dashboard"}
                                    </Typography>
                                    {mode === "signin" && (
                                        <form className={classes.form} noValidate>
                                            <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="userEmail"
                                                label="Email Address"
                                                name="userEmail"
                                                autoComplete="email"
                                                autoFocus
                                                value={email}
                                                onChange={(event) => onChangeHandler(event)}
                                            />
                                            <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                name="userPassword"
                                                label="Password"
                                                type={showPassword === false ? "password" : "text"}
                                                id="userPassword"
                                                autoComplete="current-password"
                                                value={password}
                                                onChange={(event) => onChangeHandler(event)}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment
                                                            position="end"
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <VisibilityIcon/>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <Typography variant="body1" color="error">
                                                {error}
                                            </Typography>

                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                className={classes.submit}
                                                onClick={async (event) =>
                                                    await signInWithEmailAndPasswordHandler(event)
                                                }
                                            >
                                                {"Sign In"}
                                            </Button>
                                        </form>
                                    )}
                                    {mode === "signup" && (
                                        <div style={{margin: 30, padding: "0 10%"}}>
                                            <form className={classes.form} noValidate>
                                                <SelectComponent
                                                    label="Select Role"
                                                    menuItem={UserTypes}
                                                    setSelections={setRole}
                                                    required={true}
                                                />
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    fullWidth
                                                    id="newEmail"
                                                    label="Email Address"
                                                    name="userEmail"
                                                    autoComplete="email"
                                                    autoFocus
                                                    inputRef={newEmail}

                                                    // value={email}
                                                    // onChange={(event) => onChangeHandler(event)}
                                                />
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    fullWidth
                                                    name="userPassword"
                                                    label="Password"
                                                    type={showPassword === false ? "password" : "text"}
                                                    id="newPassword"
                                                    autoComplete="current-password"
                                                    inputRef={newPassword}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment
                                                                position="end"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <VisibilityIcon/>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    // value={password}
                                                    // onChange={(event) => onChangeHandler(event)}
                                                />
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    fullWidth
                                                    name="contact number"
                                                    label="Contact Number"
                                                    type="text"
                                                    id="newMobileNumber"
                                                    autoComplete="mobile-number"
                                                    inputRef={mobileNumber}
                                                    inputProps={{
                                                        maxLength: 10, // Limits to 10 characters
                                                        inputMode: "numeric", // Ensures a numeric keyboard on mobile devices
                                                        pattern: "[0-9]*" // Only numbers allowed
                                                    }}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                    }}
                                                />
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    fullWidth
                                                    name="user Name"
                                                    label="User Name"
                                                    type="text"
                                                    id="newUserName"
                                                    autoComplete="user-name"
                                                    inputRef={userName}
                                                />

                                                <Typography variant="body1" color="error">
                                                    {error}
                                                </Typography>

                                                <Button
                                                    type="submit"
                                                    fullWidth
                                                    variant="contained"
                                                    className={classes.submit}
                                                    onClick={(event) => signUpNewUser(event)}
                                                >
                                                    {"Create User"}
                                                </Button>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </>
            )}
        </>
    );
}
